import { getClassificationValues, getPortalClassifications } from "@/api/main";
import ClassificationType from "../../../../backend/models/ClassificationType.ts";

const app = {
  state: {
    options: {
      ombudsmanNature: [],
    },
    maps: {
      ombudsmanNature: {},
    },
    enabledOptions: [],
    fieldLabels: {},
  },
  mutations: {
    SET_CLASSIFICATION: (state, { options, maps, fieldLabels }) => {
      state.options = options;
      state.maps = maps;
      state.fieldLabels = fieldLabels;
    },
    SET_ENABLED_OPTIONS: (state, options) => {
      state.enabledOptions = options;
    },
  },
  actions: {
    RefreshCompanyClassifications({ commit }, company) {
      // Validate company/slug before making request
      if (!company || company === "localhost" || company === "") {
        return Promise.resolve();
      }

      return new Promise((resolve, reject) => {
        const toSelectData = (items) => {
          const opts = [];
          for (const item of items) {
            opts.push({ value: item._id, text: item.value });
          }
          // opts.sort((a, b) => a.text.localeCompare(b.text));
          return opts;
        };

        const toMap = (items) => {
          const opts = {};
          for (const item of items) {
            opts[item._id] = item.value;
          }
          return opts;
        };

        const opts = [
          {
            name: "ombudsmanNature",
            type: ClassificationType.OMBUDSMAN_NATURE,
          },
        ];

        const options = {};
        const maps = {};
        const fieldLabels = {};
        const enabledOptions = [];
        const populate = async () => {
          {
            const resp = await getPortalClassifications(company);
            enabledOptions.push(...resp.data);
            opts.push(...resp.data);

            for (const option of resp.data) {
              const key = option.group ? `custom_${option.group}` : option.name;
              fieldLabels[key] = option.portalFieldLabel || null;
            }
          }

          for (const opt of opts) {
            const resp = await getClassificationValues(
              company,
              opt.type,
              opt.group
            );
            const key = opt.group ? `custom_${opt.group}` : opt.name;
            options[key] = toSelectData(resp.data);
            maps[key] = toMap(resp.data);
          }
        };

        populate()
          .then(() => {
            commit("SET_CLASSIFICATION", { options, maps, fieldLabels });
            commit("SET_ENABLED_OPTIONS", enabledOptions);
            resolve();
          })
          .catch(reject);
      });
    },
  },
};

export default app;
